// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JobOrder } from './job-order';
import { JobOrderNoteType } from './job-order-note-type';
import { JobOrderStatus } from './job-order-status';
import { ProximityUser } from './proximity-user';
import { JobOrderStatusEnum } from './enums';
import { JobOrderNoteTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JobOrderNote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  isIssue!: boolean;
  /** Boolean */
  isSystemGenerated!: boolean;
  /** Guid */
  jobOrderDetailId?: string;
  /** Guid FK jobOrder */
  jobOrderId!: string;
  /** Enum FK jobOrderNoteType */
  jobOrderNoteTypeId?: JobOrderNoteTypeEnum;
  /** Enum FK jobOrderStatus */
  jobOrderStatusId!: JobOrderStatusEnum;
  /** Guid FK modProximityUser */
  modProximityUserId?: string;
  /** DateTimeOffset */
  modTs?: Date;
  /** String */
  note!: string;
  /** DateTimeOffset */
  noteTs!: Date;
  /** Guid FK proximityUser */
  proximityUserId?: string;
  /** Int32 */
  sourceReturnActionId?: number;
  /** FK jobOrderId */
  jobOrder!: JobOrder;
  /** FK jobOrderNoteTypeId */
  jobOrderNoteType!: JobOrderNoteType;
  /** FK jobOrderStatusId */
  jobOrderStatus!: JobOrderStatus;
  /** FK modProximityUserId */
  modProximityUser!: ProximityUser;
  /** FK proximityUserId */
  proximityUser!: ProximityUser;
}

